"use client";

import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { GlassCard } from "@/src/components/GlassCard";
import { HOME_TESTIMONIALS } from "../home.data";

// * ─── Testimonials ───────────────────────────────────────────────────────────
export function HomeTestimonialsSection() {
  const { t } = useTranslation("common");

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-walnut-900 dark:text-white mb-4">
            {t("testimonials.title")}
          </h2>
          <p className="text-lg text-walnut-700 dark:text-walnut-300 max-w-2xl mx-auto">
            {t("testimonials.subtitle")}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {HOME_TESTIMONIALS.map((testimonial, index) => (
            <GlassCard key={index} className="p-6">
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="text-yellow-500 text-xl">
                    ★
                  </span>
                ))}
              </div>
              <p className="text-walnut-700 dark:text-walnut-300 mb-6 italic">
                &quot;{testimonial.text}&quot;
              </p>
              <div>
                <div className="font-semibold text-walnut-900 dark:text-white">
                  {testimonial.name}
                </div>
                <div className="text-sm text-walnut-600 dark:text-walnut-400">
                  {testimonial.role}, {testimonial.company}
                </div>
              </div>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  );
}
